export default {
  name: 'betterNavigatorLanguage',
  lookup (options) {
    const language = window.navigator.language
    
    if (language && language.length > 2) {
      const rootLanguage = language.split('-')[0]

      if (options.whitelist.indexOf(rootLanguage) > -1) {
        return rootLanguage
      }
    }
  }
}
